import React, { ReactElement } from 'react';
import { ToggleProps } from './types';
import View from './View';
import { useViewModel } from './viewModel';

function Main(props: ToggleProps): ReactElement {
    const viewModelProps = useViewModel(props);
    return <View {...viewModelProps} />;
}

export default Main;
